import { whiteColor } from "@config"
import createPage from "@src/components/page"
import React from "react"
import * as styles from "./pageLikes.module.scss"

import d1Img from "@images/png/16.png"
import d2Img from "@images/png/17.png"
import Numbers from "@src/components/numbers"
import { callYou, useEnteringTrail } from "@src/components/page/lib"
import { animated } from "@react-spring/web"

const parseData = ({
  attributes: {
    "post-reads-count": postReads,
    "likes-count": likes,
    "interactions-count": interactions,
  },
}) => ({
  postReads,
  likes,
  interactions,
})

const PageLikes = createPage(
  ({ data, offset }) => {
    const { postReads, likes, interactions } = parseData(data)
    const anime1Styles = useEnteringTrail(2, offset)
    const anime2Styles = useEnteringTrail(1, offset, { step: 0.4, type: "mrt" })
    const anime3Styles = useEnteringTrail(1, offset, { step: 0.4, type: "mlb" })
    return (
      <>
        {postReads > 0 && (
          <div className={styles.postReads}>
            <animated.img
              style={anime2Styles[0]}
              src={d1Img}
              className={styles.d1}
              alt="d"
            />
            <animated.div style={anime1Styles[0]}>
              2021年 {callYou(data)}一共看过
              <br />
              <div className={styles.flexTop}>
                <Numbers>{postReads}</Numbers>篇内容
              </div>
            </animated.div>
          </div>
        )}
        {(likes > 0 || interactions > 0) && (
          <div className={styles.likes}>
            <animated.div style={anime1Styles[1]}>
              {likes > 0 && (
                <div>
                  点过个<Numbers>{likes}</Numbers>喜欢
                </div>
              )}
              {interactions > 0 && (
                <div>
                  和<Numbers>{interactions}</Numbers>
                  <br />
                  位用户有过互动
                </div>
              )}
            </animated.div>
            <animated.img
              style={anime3Styles[0]}
              src={d2Img}
              className={styles.d2}
              alt="d"
            />
          </div>
        )}
      </>
    )
  },
  {
    className: styles.page,
  }
)

export const pageLikesData = {
  key: "likes",
  bg: whiteColor,
  Page: PageLikes,
  shouldHide: (data) => {
    const { postReads, likes, interactions } = parseData(data)
    return postReads === 0 && likes === 0 && interactions === 0
  },
}

PageLikes.displayName = "PageLikes"
export default PageLikes
